module.exports = __webpack_public_path__ + "static/media/_AmountSelection.0ab1b912.scss";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Cob/views/AmountSelection/_AmountSelection.scss
// module id = 434
// module chunks = 0